export function parseExcessReason(reason: string): string {
  return reason ? reason.replace(/!N!/g, '\n').trim() : '';
}

export function arrayListToString(arrayList: any[], property: string): string {
  return arrayList && property
    ? arrayList.map((item): string => item[property]).join(', ')
    : '';
}
